import React, { Fragment, useState } from 'react';
import RecordsTable from './recordsTable';
import { useFetch } from '../../lib/useFetch';
import PaginationBar from '../../components/pagination';
import { formatDate } from '../../lib/helpers';

const userHeaders = ["Price From", "Price To", "Delivery Fees", "Reward Percentage", "Fees Percentage", "Created At"];

const mapResponseData = (data) => {
  const getTrimmedObj = (obj) => {
    let trimmedObj = {}
    trimmedObj['id'] = obj['_id'];
    trimmedObj['priceFrom'] = obj.priceFrom;
    trimmedObj['priceTo'] = obj.priceTo;
    trimmedObj['deliveryFees'] = obj.deliveryFees;
    trimmedObj['rewardPercent'] = obj.rewardPercent;
    trimmedObj['moveitPercentFromTravelerReward'] = obj.moveitPercentFromTravelerReward;
    trimmedObj['createdAt'] = formatDate(new Date(obj.createdAt));
    return trimmedObj;
  }
  if (data) {
    return data.map(obj => getTrimmedObj(obj));
  }
  return [];
}

const Pricing = ({ openMainModal }) => {
  const [page, setPage] = useState(1);
  const [reload, toggleReload] = useState(false)
  const { data, loading, totalCount } = useFetch(`prices?page=${page}`, reload);

  return (
    <Fragment>
      <RecordsTable
        loading={loading}
        headers={userHeaders}
        records={mapResponseData(data)}
        openMainModal={openMainModal}
        reload={()=>toggleReload(r=> !r)}
      />

      <PaginationBar page={page} totalCount={totalCount} setPage={setPage} />
    </Fragment>
  );
}
export default Pricing;